import { getFileNameUrl } from "configs/images.config";
import PropTypes from "prop-types";
import Dropzone from "react-dropzone";
import photoClasses from "stories/components/imageUploader/ImageUploader.module.scss";
import classes from "./PhotoGallery.module.scss";

export const PhotoGallery = ({
  imageList,
  removeImageHandler,
  uploadImageHandler,
  onSelectImage,
}) => {
  const handleImageDelete = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    removeImageHandler(index);
  };
  const handleSelectImage = (index) => {
    if (onSelectImage) onSelectImage(index);
  };
  return (
    <div className={classes["wrapper"]}>
      {imageList.map((item, index) => (
        <div
          className={`${classes["image"]} ${
            item.cover ? photoClasses["cover"] : ""
          }`}
          key={item.key || item.id}
          onClick={() => handleSelectImage(index)}
        >
          <div
            role={"button"}
            className={classes["remove-icon"]}
            onClick={(e) => handleImageDelete(e, index)}
          />
          <img
            src={
              item.filename instanceof File
                ? URL.createObjectURL(item.filename)
                : getFileNameUrl(item.filename)
            }
            alt={`Gallery item ${index}`}
          />
        </div>
      ))}
      <Dropzone
        onDrop={uploadImageHandler}
        accept={{
          "image/*": [".jpeg", ".png", ".jpg"],
        }}
      >
        {({ getRootProps, getInputProps }) => (
          <div
            {...getRootProps()}
            data-testid="upload-img"
            className={`${classes["image"]} ${classes["uploader"]}`}
          >
            <input {...getInputProps()} />
            <div className={"icon-upload"} />
            <div role="button">Upload Image</div>
          </div>
        )}
      </Dropzone>
    </div>
  );
};

PhotoGallery.propTypes = {
  /**
   * list of images containing id and url
   */
  // imageList: PropTypes.arrayOf(PropTypes.exact(ImageModel)),
  imageList: PropTypes.arrayOf(PropTypes.any),
  /**
   * handler function to be called after remove icon is clicked
   */
  removeImageHandler: PropTypes.func,
  /**
   * handler function to be called after upload section is clicked
   */
  uploadImageHandler: PropTypes.func,
};

PhotoGallery.defaultProps = {
  imageList: undefined,
  removeImageHandler: undefined,
  uploadImageHandler: undefined,
};
